import {
  Col,
  Row,
  Select,
} from "antd";
import { user_role } from "../../consts";
import { useSelector, useDispatch } from "react-redux";
import UserInfo from "../userInfo";
import { useGetAllUsers } from "../../utils/queryUtils.js"

export default function FySidebar({ query, handleFyUpdate, role, firstClick, setfirstClick, disabled = false }) {
  // const { all: all_users } = useSelector((st) => st.user);
  const data = useGetAllUsers();
  const all_users = data?.data?.data;
  const { company: selected } = useSelector((st) => st.selected)

  const handleClick = () => {
    if (firstClick) {
      setfirstClick(false)
    }
  }


  if (disabled) {
    return (
      <Row
        gutter={[10, 25]}
        style={{
          width: "100%",
          alignItems: "center",
        }}
        className="d-flex flex-column"
      >
        <Col span={24} className="w-100">
          <UserInfo
            firstName={query.assigned_to?.first_name || "Unassigned"}
            lastName={query.assigned_to?.last_name}
          />
        </Col>
      </Row>
    );
  }
  return (
    <Row
      gutter={[10, 25]}
      style={{
        width: "100%",
        alignItems: "center",
      }}
      className="d-flex flex-column"
    >
      <Col span={24} className="w-100">

        <div>
          {role === user_role.COMPANY ? (
            <UserInfo
              firstName={query.assigned_to?.first_name || "Unassigned"}
              lastName={query.assigned_to?.last_name}
            />
          ) : (
            <Select
              value={
                query.assigned_to?.first_name && query.assigned_to?.last_name
                  ? `${query.assigned_to?.first_name} ${query.assigned_to?.last_name}`
                  : "Unassigned"
              }
              size="medium"
              style={{ minWidth: "100%" }}
              onChange={(e) => handleFyUpdate({ assigned_to: e })}
              onClick={handleClick}
            >
              {all_users
                ?.filter(
                  (e) =>
                    e.role === user_role.ADMIN ||
                    e.company_ids?.some((f) => f._id === selected._id)
                )
                ?.map((g) => (
                  <Select.Option value={g._id} key={g._id}>
                    <UserInfo firstName={g.first_name} lastName={g.last_name} />
                  </Select.Option>
                ))}
            </Select>
          )}
        </div>
      </Col>
    </Row>
  );
}
